import React from 'react';

import { DEFAULT_STYLES } from '../../constants';
import { ComboBoxLoadingStateProps } from '../../types/comboBoxComponentTypes';

import { CustomLoaderIconContainer } from '../ComboBox/styledComponents';

export const ComboBoxLoadingState: React.FC<ComboBoxLoadingStateProps> = ({
  customLoader,
  loadingMessage,
  loadingText
}) => (
  <div className="flex flex-col items-center gap-2 py-4">
    {customLoader && (
      <CustomLoaderIconContainer>{customLoader}</CustomLoaderIconContainer>
    )}
    <div className={DEFAULT_STYLES.dropdown__loading}>
      {loadingMessage || loadingText}
    </div>
  </div>
);

ComboBoxLoadingState.displayName = 'ComboBoxLoadingState';
